import { clsx } from 'clsx';
import { FunctionComponent, PropsWithChildren } from 'react';
import { Spinner } from 'softcat:components/spinner.tsx';

type ButtonProperties = {
    disabled?: boolean;
    focus?: boolean;
    onClick?: () => void;
    style: 'confirm' | 'cancel' | 'submit';
    thinking?: boolean;
};

export const Button: FunctionComponent<PropsWithChildren<ButtonProperties>> = ({ children, disabled, focus = false, onClick, style, thinking }) => {
    return (
        <button
            className={clsx('inline-flex w-full justify-center rounded-md px-3 py-2 text-sm font-semibold shadow-sm sm:w-auto', {
                'bg-indigo-600 text-white outline-indigo-300 ring-0 hover:enabled:bg-indigo-500': style === 'submit',
                'bg-red-600 text-white outline-red-300 ring-0 hover:enabled:bg-red-500': style === 'confirm',
                'bg-white text-gray-900 outline-gray-300 ring-1 ring-inset ring-gray-300 hover:enabled:bg-gray-50': style === 'cancel',
                'opacity-50': disabled,
            })}
            data-autofocus={focus}
            disabled={disabled || thinking}
            onClick={onClick}
            type={onClick ? 'button' : 'submit'}
        >
            <span className={clsx({ 'opacity-0': thinking })}>{children}</span>

            {thinking && (
                <div className={'absolute'}>
                    <Spinner colour={'text-white'} />
                </div>
            )}
        </button>
    );
};
